export const BUTTON_VARIANT_M = 'm';
export const BUTTON_VARIANT_S = 's';
export const BUTTON_VARIANT_OUTLINE = 'outline-solid';
export const BUTTON_VARIANT_CLEAN = 'clean';
export const BUTTON_VARIANT_FILL = 'fill';
export const BUTTON_VARIANT_CTA = 'cta';
export const BUTTON_VARIANT_FILTER = 'filter';

/** `ButtonIcon`'s enabled FILL look, shared with triggers that cannot be a `ButtonIcon` themselves. */
export const BUTTON_ICON_FILL_CLASSES =
  'text-primary fill-tertiary active:fill-tertiary-active focus-visible:fill-tertiary-active cursor-pointer';

/** Shared with `ActionItemLockedButton`. */
export const ACTION_ITEM_BUTTON_CLASSES =
  'flex items-center rounded-lg px-6 xs:px-4 py-4 xs:py-2 text-headline-xs xs:text-subtitle-m w-full gap-3 text-left';
export const ACTION_ITEM_BUTTON_DISABLED_CLASSES = 'fill-secondary-disabled text-transparent-20';
